var scope_0 = require('/home/runner/work/curam-performance-tuning/curam-performance-tuning/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a0f967fac821f6c24d0f6d80bdc7237.js').default;
var scope_1 = require('/home/runner/work/curam-performance-tuning/curam-performance-tuning/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    